import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Searchbox } from 'seagull';
import styles from './AddServices.module.scss';
import { AddServicesTestIds } from './AddServicesTestIds';
export const AddServicesSearchbox = (param)=>{
    let { searchTerm, onSearchChange, onSearchClear } = param;
    return /*#__PURE__*/ _jsx(Searchbox, {
        bi: {
            name: 'included_services_search'
        },
        className: styles.searchbox,
        testId: AddServicesTestIds.SearchInput(),
        placeholder: "Search",
        value: searchTerm,
        onChange: (e)=>onSearchChange(e.target.value),
        onClear: onSearchClear
    });
};
